import { render } from "./TheStationsGenerals.vue?vue&type=template&id=15260f82"
import script from "./TheStationsGenerals.vue?vue&type=script&lang=js"
export * from "./TheStationsGenerals.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__